// extracted by mini-css-extract-plugin
module.exports = {"alignLeft":"_3V8-G","alignRight":"_1739b","sizeFullWidth":"_1g3hO","sizeContentWidth":"_1lEQT","sizeSmallCenter":"YuKL8","sizeOriginal":"_3Dm_F"};